// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"f75f00587f763032","170":"247f387df5e72d0e","521":"74454d4c87909dbe","777":"da89dd93ad8b2277","964":"22a737e5960f76ad"}[chunkId] + ".js";
};